export { View as Tab2021 } from './view'
